import { getApiClient, initializeApiClient } from "../Api/ApiServices";

export const UpdateConflictOfInterest = async (param) => {
  await initializeApiClient();
  const apiClient = await getApiClient();
  const response = await apiClient.post(
    "api/ConflictsOfInterestAndResearchEthics/UpdateConflictsOfInterestAndResearchEthics",
    param
  );

  return response;
};
